module.exports = __webpack_public_path__ + "static/media/Steppr loyalty and gifting - Grounded Body Scrub.1df438f3.webp";